function RP6FormTracking(event) {
  var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
  //var errorElem = $('.field-validation-error').text();
  var successElem = $('.field-validation-valid').text();
  if( successElem.length && ( $('#ContactMe_Email, #MailAFriend_EmailFrom, #ContactInfo_Email').val().length > 0 ) ){
    gtag('event', 'FORM SUBMIT (Success)', {
      'event_category': linkURL
    });
    console.log('success');
  } else {
    gtag('event', 'FORM SUBMIT (Error)', {
      'event_category': linkURL
    });
    console.log('error');
  }
}

if( typeof RP6_TRACKING !== "undefined" && RP6_TRACKING.GA ){

  /*var ToBeTracked? = {
    r: '.wrap--list-item .btn',
    s: '.wrap--content .btn',
  };*/
  var RP6form = document.querySelector(".form:not(.form--search)");
  if(RP6form){ RP6form.addEventListener('submit', RP6FormTracking); }

  $('form [type="submit"]').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    gtag('event', 'FORM SUBMIT (Click)', {
      'event_category': linkURL,
      'event_label': linkText
    });
  });

  $('.btn--owner').on('click', function(e) {
    gtag('event', 'login', {
      'method': 'ownerlogin'
    });
  });

  $('.btn--phone, .btn--contact, .card--team a, .card--office a').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    gtag('event', 'CONTACT', {
      'event_category': linkText,
      'event_label': linkURL
    });
  });

  $('.controller-prev, .controller-next').on('click', function(e) {
    var linkText = $(e.target).text();
    var stepElem = $(e.target).closest('article.active').attr('id');
    gtag('event', 'SUBSCRIBE', {
      'event_category': linkText,
      'event_label': stepElem
    });
    gtag('event', 'screen_view', {
      'screen_name': stepElem
    });
  });

  $('.btn--cta').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    gtag('event', 'CTA', {
      'event_category': linkText,
      'event_label': linkURL
    });
  });

  $('.btn--search, .btn--expand, .bootstrap-select .btn').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    gtag('event', 'SEARCH ACTIONS', {
      'event_category': linkText,
      'event_label': linkURL
    });
  });

  $('.carousel-control-prev, .carousel-control-next, .carousel-indicators li, .btn--cookies, .btn--view--map, .btn--view--list, .btn--view--gallery, .btn--backtotop').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    var parentElem = $(e.target).closest('div').attr('id');
    if ( !parentElem ){ parentElem = 'N/A'; }
    gtag('event', 'SITE INTERACTIONS', {
      'event_category': linkText,
      'event_label': linkURL,
      'name': parentElem
    });
  });

  $('.nav--media .nav-link, .nav-tabs--detail-table .nav-link, .nav--links .nav-link, .navigation--detail .btn').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    var pageTitle = $('h1').text();
    gtag('event', 'PUB INTERACTIONS', {
      'event_category': linkText,
      'event_label': linkURL,
      'name': pageTitle
    });
  });

  $('.nav--social .nav-link').on('click', function(e) {
    var linkURL = window.location.pathname.slice(1, -1).replace(/\//g, '-');
    var linkText = $(e.target).text();
    gtag('event', 'SOCIAL', {
      'event_category': linkText,
      'event_label': linkURL
    });
  });

  $('.nav--share .nav-link').on('click', function(e) {
    var linkURL = window.location.pathname;
    var linkID = linkURL.substring(linkURL.lastIndexOf('/')+1);
    var linkText = $(e.target).text();
    var pageTitle = $('h1').text();
    gtag('event', 'share', {
      'method': linkText,
      'content_type': 'pub',
      'content_id': linkID,
      'name': pageTitle
    });
  });

}
